import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppService } from '../shared/app.service';
import { defaultCacheTime, INotitieDb } from '../shared/offline/cobradb';
import { of } from 'rxjs';
import { state2, IStateOptions2, ISearchResult } from '../shared/state';
import { tap } from 'rxjs/operators';
import { INotitiesSearchArg } from 'src/app/shared/routing-params/RoutingParams';
import { ICommonSearchArgs } from 'src/app/shared/common-search-args';


export interface INotitie {
  Id: number;
  Inhoud: string;
  AgendapuntId: number;
  Eigenaar: string;
  DatumUpdate: string | Date;
}

export interface IPersoon {
  Id: number;
  Naam: string;
  isSelected?: boolean;
  canSelect?: boolean;
}

export interface IPartij {
  Id: number;
  Naam: string;
  isSelected?: boolean;
  Leden: IPersoon[];
}


export interface INieuweNotitie {
  Id?: number;
  AgendapuntId: number;
  NotitieContent: string;
  PersoonIds: number[];
}
export interface IReageerNotitie {
  Notitie: INotitie;
  NotitieToegangen: number[];
}

export interface IReageerNotitieData {
  Partijen: IPartij[];
  ReageerNotitie: IReageerNotitie;
}

const pageSize = 5;
export const defaultNotitieStateOptions: IStateOptions2 = { allowFromCache: false, concat: false, page: 0, pageSize };

@Injectable()
export class NotitiesService {

  constructor(private http: HttpClient, private appService: AppService) { }

  getRecenteNotities(page: number) {
    const url = this.appService.getUrl(`api/notitie/getrecentenotities?page=${page}`);
    return state2.getValueOrDefault('recentenotities', this.http.get<INotitieDb[]>(url), defaultCacheTime);
  }

  getActieveLedenPerPartij(agendapuntId: number) {
    const url = this.appService.getUrl(`api/notitie/getactieveleden?agendapuntId=${agendapuntId}`);
    return this.http.post<IPartij[]>(url, {});
  }
  toevoegenNotitie(notitieModel: INieuweNotitie) {
    const url = this.appService.getUrl('api/notitie/toevoegennotitie');
    return this.http.post<boolean>(url, notitieModel).pipe(
      tap(_ => state2.removeSubKey('detailagendapuntdata', notitieModel.AgendapuntId))
    );
  }
  reageerNotitie(notitieId: number) {
    const url = this.appService.getUrl(`api/notitie/ReageerNotitie?notitieId=${notitieId}`);
    return this.http.post<IReageerNotitie>(url, {}).pipe(
      tap(result => state2.removeSubKey('detailagendapuntdata', result.Notitie.AgendapuntId))
    );
  }

  updateNotitie(notitieModel: INieuweNotitie) {
    const url = this.appService.getUrl('api/notitie/updateNotitie');
    return this.http.post<boolean>(url, notitieModel).pipe(
      tap(_ => state2.removeSubKey('detailagendapuntdata', notitieModel.AgendapuntId))
    );
  }

  zoekNotities(searchArg: ICommonSearchArgs) {
    searchArg.SoortNotities = searchArg.SoortNotities ?? 'alle';
    if (!searchArg.SearchFor) { return of({ items: [], hasMoreResults: false, page: 0 } as ISearchResult<INotitieDb>); }
    const url = this.appService.getUrl('api/notitie/zoeknotities');
    const stateOptions: IStateOptions2 = { ...defaultNotitieStateOptions, ...window.history.state as IStateOptions2 };
    stateOptions.pageSize = 5;
    searchArg.CurrentPage = stateOptions.page;
    // console.log(`zoekNotities CurrentPage:${searchArg.CurrentPage}, stateoptions:${JSON.stringify(stateOptions)}`);
    return state2.getSearchResultOrDefault('notitiesearchresults',
      this.http.post<INotitieDb[]>(url, { ...searchArg, PageSize: 5 }),
      stateOptions);
  }

  setNotitieGelezen(notitieToegangId: number) {
    const url = this.appService.getUrl(`api/notitie/setnotitiegelezen?notitieToegangId=${notitieToegangId}`);
    return this.http.post(url, {});
  }
}
